<template>
  <div class="label-cloud">
    <button
      v-for="(label, index) in labels"
      :key="index"
      :class="{ selected: selected === index }"
      @click.prevent="onLabelClicked(index)"
    >
      {{ $t(label) }}
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      labels: {
        type: Object,
        required: true
      },
      selected: {
        type: String,
        required: false,
        default: null
      }
    },
    methods: {
      onLabelClicked(key) {
        this.$emit('click', key)
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .label-cloud {
    user-select: none;
    padding: 25px 20px 24px 16px;
    overflow-x: auto;
    display: block;
    white-space: nowrap;

    @include bp-mf-tablet() {
      overflow-x: unset;
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      padding: 6px 20px 16px 16px;
      flex-direction: row;
    }

    button {
      cursor: pointer;
      display: inline-block;
      font-size: em(13);
      line-height: 15px;
      color: $blue-dark;
      margin: 0 8px 0 0;
      padding: 3px 13px;
      transition: 0.2s ease;
      width: auto;

      box-sizing: border-box;
      border: 1px solid $grey-border;
      border-radius: 12px;

      @include outline-focus;

      &:focus-visible {
        border-radius: 12px;
      }

      @include bp-mf-tablet() {
        margin: 9px 8px 0 0;
      }

      &.selected {
        background: $green-base;
        color: $grey-default;
        font-weight: 500;
      }

      @include bp-mf-desktop() {
        &:hover {
          border: 1px solid $green-base;
          background: $green-base;
          color: $grey-default;
        }
      }
    }
  }
</style>
